// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope } from "~/hooks/useScope";
import { UPDATE_SPACE } from "./action";

export function canUpdateSpace(scope: Scope): boolean {
  return scope.iamActions.includes(UPDATE_SPACE);
}
